export const RATE_PLAN_TYPE = {
  "PURCHASE": "Purchase",
  "SALE": "Sale"
}

export const RatePlanType = {
  "Purchase": "Zakupowy",
  "Sale": "Sprzedażowy"
}